import { useTranslation } from 'react-i18next';
import { DocumentTitle } from '@/shared/components/DocumentTitle.tsx';
import { FullscreenLoadingSuspenseBoundary } from '@/shared/components/FullscreenLoadingSuspenseBoundary.tsx';
import { SalesforceDealImporter } from './components/SalesforceDealImporter';
import { PageHeader } from '@/shared/components/PageHeader';
import { environment } from '@/environment.ts';
import { GetConstructionProjectResponse } from '@/clients/constructionProject/types/constructionProject.ts';

type SalesforceDealImporterPageProps = {
    opportunityId: string;
    constructionProject: GetConstructionProjectResponse;
};

export function SalesforceDealImporterPage({ opportunityId, constructionProject }: SalesforceDealImporterPageProps) {
    const { t } = useTranslation();

    return (
        <>
            <DocumentTitle title={t('positions.create-position')} />
            <FullscreenLoadingSuspenseBoundary>
                <div className="bg-light-gray-200 flex min-h-screen flex-col gap-16">
                    <PageHeader
                        title={t('positions.create-position')}
                        onCloseClickPath={`${environment.SALESFORCE_HOST_URL}/lightning/r/Opportunity/${opportunityId}/view`}
                    />
                    <SalesforceDealImporter
                        opportunityId={opportunityId}
                        constructionProjectId={constructionProject.id}
                    />
                </div>
            </FullscreenLoadingSuspenseBoundary>
        </>
    );
}
